// import components
import { Box, IconButton, styled } from '@mui/material';

/**
 * The symbols in a row, set tighter than the toolbar's own icon spacing: they are one control that happens
 * to have several states, so they should read as a group rather than as separate buttons. Stacked instead
 * when the toolbar is docked to the side, so the group follows the bar it sits in.
 */
export const EntityTypeRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isVertical'
})<{ isVertical?: boolean }>(({ theme, isVertical }) => ({
  display: 'flex',
  flexDirection: isVertical ? 'column' : 'row',
  alignItems: 'center',
  gap: theme.spacing(0.25)
}));

/**
 * One symbol. Active carries the entity's own colour — the same colour the grid uses in front of the
 * name — and inactive greys out, so the toolbar reads at a glance as "this is what you are looking at".
 */
export const EntityTypeButton = styled(IconButton, {
  shouldForwardProp: (prop) =>
    prop !== 'isActive' && prop !== 'activeColor' && prop !== 'nudgeRight'
})<{ isActive?: boolean; activeColor?: string; nudgeRight?: boolean }>(
  ({ theme, isActive, activeColor, nudgeRight }) => ({
    color: isActive ? activeColor : theme.palette.action.disabled,
    // The care receiver's glyph sits further left inside its box than the other three, so it reads as out
    // of line with them. Nudged by the theme's smallest step, which brings it onto the same visual edge
    // without moving the other three.
    ...(nudgeRight ? { marginLeft: theme.spacing(0.25) } : {}),
    '&.Mui-disabled': {
      color: theme.palette.action.disabled
    }
  })
);
